import { render, staticRenderFns } from "./DomainsBlacklistPage.vue?vue&type=template&id=76cdcee0&scoped=true"
import script from "./DomainsBlacklistPage.vue?vue&type=script&lang=js"
export * from "./DomainsBlacklistPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cdcee0",
  null
  
)

export default component.exports